package pt.at.oss.kotlin.manual.schema.common.websites

import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.WEBSITE_MAX_LEN
import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.WEBSITE_MIN_LEN
import pt.at.oss.kotlin.manual.storage.common.websites.WebsitesEntry
import pt.lightweightform.kotlin.schema.RecordSchema
import pt.lightweightform.kotlin.schema.StringSchema
import pt.lightweightform.kotlin.type.validator.ValidationErrors
import pt.lightweightform.kotlin.util.appendToPath

/**
 * WebsitesEntrySchema Schema object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
class WebsitesEntrySchema : RecordSchema<WebsitesEntry>(name = "websites") {

    val nameSchema: StringSchema = StringSchema(name = "name", minLength = WEBSITE_MIN_LEN, maxLength = WEBSITE_MAX_LEN)
    override fun isValid(value: WebsitesEntry?): Boolean {
        return value == null || (
            nameSchema.isValid(value.name)
            )
    }

    override fun validate(value: WebsitesEntry?, path: String): ValidationErrors {
        val validator = super.validate(value, path)
        if (value === null) {
            return validator
        }
        validator.addErrors(nameSchema.validate(value.name, appendToPath(path, "name")))
        return validator
    }
}
